import { isSameDay } from './is-same-day.mjs';

function isToday(date, timeZone) {
  return isSameDay(date, new Date(), timeZone);
}

export { isToday };
